import React from 'react'
import { TradersList } from './list/page'

export const TradersPage = () => {
  return <TradersList />
}
